<script>
import {required} from 'vuelidate/lib/validators'
import * as avaliacaoService from '../services/avaliacaoService'
import swal from 'sweetalert2'
import {mapActions} from 'vuex'

export default {
  name: 'avaliacao-redacao',
  props: {
    avaliacao: Object,
    etapa: String,
    isLoading: Boolean
  },
  data () {
    return {
      showLoaderOnSave: false,
      saveInterval: null,
      limitCharacters: 1600
    }
  },
  computed: {
    tema: {
      get () {
        return this.avaliacao.tema
      }
    },
    redacao: {
      get () {
        return this.avaliacao.redacao
      },
      set (redacao) {
        this.avaliacao.redacao = redacao
        this.$emit('update:avaliacao', this.avaliacao)
      }
    },
    countCharacters () {
      return this.avaliacao.redacao.texto.length
    }
  },
  validations: {
    redacao: {
      titulo: {required},
      texto: {required}
    }
  },
  mounted () {
    this.saveInterval = setInterval(() => {
      this.showLoaderOnSave = false
      this.salvar()
    }, 60000)
  },
  beforeDestroy () {
    clearInterval(this.saveInterval)
  },
  methods: {
    ...mapActions(['showNotification']),
    voltar () {
      this.$emit('update:etapa', 'tema')
    },
    salvar () {
      if (this.$v.redacao.$invalid) {
        return
      }

      if (this.showLoaderOnSave) {
        this.$emit('update:is-loading', true)
      }

      const formData = {
        id: this.avaliacao.id,
        redacao: this.avaliacao.redacao,
        tema: this.avaliacao.tema,
        finalizada: false
      }

      avaliacaoService.salvarRedacao(formData).then(() => {
        this.$emit('update:is-loading', false)
        this.showNotification({
          title: 'Sucesso!',
          message: 'Sua redação foi salva.',
          timeout: 5000
        })
      }).catch(e => {
        this.$emit('update:is-loading', false)
        console.log(e)
      })
    },
    finalizar () {
      swal({
        title: 'Finalizar redação?',
        text: 'Tem certeza que deseja finalizar? Após a finalização não é possível alterar a redação.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#4caf50',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, finalizar!',
        cancelButtonText: 'Não'
      }).then((result) => {
        if (result) {
          this.$emit('update:is-loading', true)

          const formData = {
            id: this.avaliacao.id,
            redacao: this.avaliacao.redacao,
            tema: this.avaliacao.tema,
            finalizada: true
          }

          avaliacaoService.finalizarRedacao(formData).then((response) => {
            this.$emit('update:is-loading', false)
            this.$emit('update:etapa', 'confirmacao')
          }).catch(e => {
            this.$emit('update:is-loading', false)
            console.log(e)
          })
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<template>
  <div class="avaliacao-redacao">
    <div class="page-content">
      <div class="page-header-content">
        <h2 class="page-title">Sua redação</h2>
      </div>
    </div>

    <div class="box pa-3">
      <div class="text-xs-center">
        <h3 class="title mb-1">
          Tema: <span class="font-weight-regular">{{ tema.titulo }}</span>
        </h3>
        (<a :href="tema.enunciado" target="_blank">Clique aqui para visualizar o enunciado</a>)
      </div>

      <v-divider class="my-3"/>

      <div class="mb-3">
        <v-text-field
          v-model="redacao.titulo"
          label="Título"
          box
          hide-details/>
      </div>

      <div class="mb-3" @cut.prevent @copy.prevent @paste.prevent>
        <v-textarea
          v-model="redacao.texto"
          label="Texto"
          box
          auto-grow
          hide-details/>
      </div>
      <div class="mb-3">
      Nº de caracteres: {{countCharacters}}
      </div>
      <div class="mb-3">
        <v-alert :value="true" type="warning">
          - A redação deve possuir no mínimo {{limitCharacters}} caracteres para ser finalizada;<br>
          - Ao clicar em salvar, essa redação será salva e poderá ser acessada novamente através do link enviado no e-mail;<br>
          - Ao clicar em finalizar, a redação será enviada e não poderá mais ser acessada.
        </v-alert>
      </div>

      <div class="acoes-wrapper">
        <div class="btn-voltar-wrapper grow">
          <v-btn color="primary"
                 depressed
                 large
                 @click="voltar()"
                 class="btn-voltar ma-0">
            <i class="fas fa-arrow-circle-left"></i>
            <span class="pl-1">Voltar</span>
          </v-btn>
        </div>

        <div class="acoes">
          <div>
            <v-btn color="primary"
                   depressed
                   large
                   @click="showLoaderOnSave = true; salvar()"
                   :disabled="$v.redacao.$invalid"
                   class="ma-0">
              <i class="far fa-save"></i>
              <span class="pl-1">Salvar</span>
            </v-btn>
          </div>
          
          <div class="ml-3">
            <v-btn color="primary"
                   depressed
                   large
                   @click="finalizar()"
                   :disabled="$v.redacao.$invalid || (countCharacters < limitCharacters)"
                   class="ma-0">
              <i class="fas fa-gavel"></i>
              <span class="pl-1">Finalizar</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.avaliacao-redacao {
  .acoes-wrapper,
  .acoes {
    display: flex;
  }
}

@media all and (max-width: 599px) {
  .avaliacao-redacao {
    .acoes-wrapper {
      flex-direction: column-reverse;
    }

    .acoes {
      flex-direction: column;

      > div {
        width: 100%;

        &.ml-3 {
          margin-left: 0 !important;
          margin-top: 8px;
        }

        > button {
          width: 100%;
        }
      }
    }

    .btn-voltar-wrapper {
      margin-top: 32px;
    }

    .btn-voltar {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Redacao.vue?1c2f28b8